import { Button } from "@shltelemedicine/shl-ui-lib";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import supportMenuIcon from "../../assets/nav/menu_support.svg";
import {
  MainContextActionType,
  useMainContext,
} from "../../context/MainContext";
import { useMainRoutes } from "../../hooks/useMainRoutes";
import styles from "./Sidebar.module.css";
import UserInfo from "./UserInfo";

type SideBarProps = {
  onItemClick?: () => void;
};

const Sidebar = ({ onItemClick }: SideBarProps) => {
  const { dispatch } = useMainContext();

  const { links } = useMainRoutes();

  const handleShowSupportModal = () =>
    dispatch({
      type: MainContextActionType.SET_SHOW_SUPPORT,
      payload: { show: true },
    });

  return (
    <div className={`fixed h-100 pt-4 ${styles.menuSideBar}`}>
      <div className={`${styles.menuItem} mt-4 mt-md-5 mb-3 d-inline-block `}>
        <UserInfo showName={true} />
      </div>
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          onClick={() => {
            l.onCLick!;
            onItemClick!();
          }}
          className={`${styles.menuItem}`}
        >
          <img src={l.icon} alt="" />
          &nbsp; <FormattedMessage id={l.label} defaultMessage={l.to} />
        </NavLink>
      ))}
      <Button
        variant=""
        onClick={handleShowSupportModal}
        className={styles.supportItem}
      >
        <img src={supportMenuIcon} alt="" />
        &nbsp; <FormattedMessage id={"NAV.SUPPORT"} />
      </Button>
    </div>
  );
};

export default Sidebar;
